const IslandLabel = ({ levelText, titleText, x, y, styles, scale = 1 }) => (
  <svg
    x={x}
    y={y}
    width={scale * 116}
    height={scale * 72}
    viewBox="0 0 116 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter={`url(#filter0_d${titleText})`}>
      <rect
        x="4.91528"
        y="0.927246"
        width="107"
        height="62.7363"
        rx="10"
        fill="white"
      />
      <text
        x="50%"
        y="24.6876"
        textAnchor="middle"
        className={styles.island_label_level}
        // intentionally not using design system typography
        // since this text will be scaled by the SVG scaling
        style={{ fontSize: "16px" }}
      >
        {levelText}
      </text>
      <text
        x="50%"
        y="48.0036"
        textAnchor="middle"
        className={styles.island_label_title}
        // intentionally not using design system typography
        // since this text will be scaled by the SVG scaling
        style={{ fontSize: "20px" }}
      >
        {titleText}
      </text>
    </g>
    <defs>
      <filter
        id={`filter0_d${titleText}`}
        x="0.915283"
        y="0.927246"
        width="115"
        height="70.7363"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

IslandLabel.propTypes = {
  levelText: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  styles: PropTypes.shape({
    island_label_level: PropTypes.string.isRequired,
    island_label_title: PropTypes.string.isRequired,
  }).isRequired,
  scale: PropTypes.number,
};

export default IslandLabel;
